import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSettings } from '../context/SettingsContext';
import { applyCustomCode } from '../lib/customCode';
import { cacheAdminPathIsPortal, isPanelPath } from '../lib/adminDomain';

const CustomCodeInjector = () => {
  const settings = useSettings();
  const { pathname } = useLocation();
  // Panel kilitliyken ana sitedeki /admin portalın 404 sayfasıdır ve temanın
  // geri kalanı gibi özel kodu da taşır (bkz. lib/adminDomain.isPanelPath).
  const isAdmin = isPanelPath(settings, pathname);
  const adminDomainEnabled = settings.admin_domain_enabled;
  const adminDomainLocked = settings.admin_domain_locked;
  const adminHost = settings.admin_host;
  // Parçalar ``settings`` satırında değil kendi tablosundadır: CSS ve JS
  // **adres olarak** gelir (dosya tarayıcı önbelleğine girsin diye), satır içi
  // slotlar ham HTML olarak. Bkz. backend/services/custom_code.py.
  const code = settings.custom_code || {};
  const cssUrl = code.css_url || '';
  const cssMobileUrl = code.css_mobile_url || '';
  const jsUrl = code.js_url || '';
  const headerCode = code.header || '';
  const bodyCode = code.body || '';
  const footerCode = code.footer || '';

  useEffect(() => {
    if (!settings.settingsLoaded) return;
    // Uygulama durumu modülde tutulur (bkz. lib/customCode.js): aynı satır içi
    // kod ikinci kez çalıştırılmaz, panele geçişte düğümler sökülür, portala
    // dönüşte aynı düğümler geri takılır. Efektin temizleme adımı bilinçli
    // olarak yoktur — sökme kararını `enabled` verir; cleanup'ta sökmek
    // StrictMode'da ve her ayar yenilemesinde widget'ı ikinci kez yükletiyordu.
    cacheAdminPathIsPortal({
      admin_domain_enabled: adminDomainEnabled,
      admin_domain_locked: adminDomainLocked,
      admin_host: adminHost,
    });
    applyCustomCode({
      cssUrl,
      cssMobileUrl,
      jsUrl,
      headerCode,
      bodyCode,
      footerCode,
      enabled: !isAdmin,
    });
  }, [
    adminDomainEnabled, adminDomainLocked, adminHost,
    bodyCode, cssMobileUrl, cssUrl, footerCode, headerCode, isAdmin, jsUrl,
    settings.settingsLoaded,
  ]);

  return null;
};

export default CustomCodeInjector;
